<div *ngIf="Notifications.length != 0" class="toast-wraper">
    <div class="wrap">
        <app-common-message-modal [successMessage]="Notifications"
    (showNotification)="closeModalFun($event)"></app-common-message-modal>
      </div>
</div>
